import * as yup from "yup";

export const defaultFormValues = {
  code: "",
  enabled: true,
  instructions: "",
};

export const schema = yup.object({
  code: yup.string().required("Code required"),
  enabled: yup.boolean().required(),
  instructions: yup.string(),
});
